/* eslint-disable no-undef */
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import * as React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';

import loginLogo from '../../../images/unused-undraw-illustrations/undraw_secure_login_pdn4.svg';
import { removeQueryParam } from '../../../utils/urlHelper';

const defaultCardStyle = {
  width: '500px',
  margin: 'auto',
  maxWidth: '90vw',
};

const getHeader = (error, description) => {
  if (description === 'Please verify your email before logging in.') {
    return 'Email Verification Required'
  } if (description && description.indexOf('found your existing account') >= 0) {
    return 'Welcome Back!';
  }
  return 'Authentication Error'
}
const getTitle = (error, description) => {
  if (description === 'Please verify your email before logging in.') {
    return 'Verify Your Email First'
  } if (description && description.indexOf('found your existing account') >= 0) {
    return 'We have linked your accounts.';
  }
  return error || 'Error Logging In'
}

const getDescription = (error, description) => {
  if (description === 'Please verify your email before logging in.') {
    return 'You will receive and email at the address you used when you signed up. Note that it can sometimes take a few minutes for this email to arrive!'
  } if (description && description.indexOf('found your existing account') >= 0) {
    return description;
  }
  return error || 'There was an error logging in, please try again. If the issue persists, please contact support.'
}

const LimitedAccessCardComponent = ({ query: parmQuery }) => {
  const [query, setQuery] = React.useState({});
  const { loginWithRedirect } = useAuth0();

  React.useEffect(() => {
    if (parmQuery && parmQuery.error && parmQuery.error_description) {
      setQuery(parmQuery);
      removeQueryParam('error')
      removeQueryParam('error_description')
      removeQueryParam('state')
    }
  }, [parmQuery])

  return (
    <Box sx={{ mt: 2 }}>
      <Card style={defaultCardStyle}>
        <CardHeader title={getHeader(query.error, query.error_description)} />
        <CardContent>
          <Typography variant="h5">{getTitle(query.error, query.error_description)}</Typography>
          <Typography
            gutterBottom
            sx={{
              mt: 4,
              mb: 2,
            }}
          >
            {getDescription(query.error, query.error_description)}
          </Typography>
          <Box
            sx={{
              textAlign: 'center',
              m: 4,
            }}
          >
            <img
              src={loginLogo}
              alt="woman with laptop"
              style={{
                width: 300,
                display: 'block',
                margin: 'auto',
                marginBottom: '1rem',
              }}
            />
          </Box>
          {
            (query.error_description === 'Please verify your email before logging in.') && (
              <Box
                sx={{
                  textAlign: 'center',
                  gap: 4,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  mt: 4,
                }}
              >
                <Button variant="contained" onClick={() => { window.location.href = '/' }}>I Have Verified My Email</Button>
                <Alert
                  severity="info"
                  variant="outlined"
                  sx={{ width: '100%' }}
                >
                  We have emailed you another link to verify your email address. Please check your inbox and spam folder.
                </Alert>
              </Box>
            )
          }

          {
            (query.error_description === 'Please verify your email before logging in.') && (
              <Box
                sx={{
                  textAlign: 'center',
                  mt: 2,
                }}
              >
                <Typography variant="caption">
                  If you have not verified your email and you press this button, you will be taken back to the login screen.
                </Typography>
              </Box>
            )
          }
          {
            (query.error_description && query.error_description.indexOf('found your existing account') >= 0) && (
              <Box
                sx={{
                  textAlign: 'center',
                  mt: 4,
                }}
              >
                <Alert
                  severity="info"
                  variant="outlined"
                  sx={{ width: '100%' }}
                >
                  Now that your Questri accounts are linked, you will need to log in again.
                </Alert>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ mt: 2 }}
                  onClick={() => {
                    loginWithRedirect({ appState: { returnTo: window.location.pathname + window.location.search } });
                  }}
                >
                  Log In Again
                </Button>
              </Box>
            )
          }
        </CardContent>
      </Card>
    </Box>
  )
}

LimitedAccessCardComponent.propTypes = { query: PropTypes.any };

LimitedAccessCardComponent.defaultProps = { query: {} };

export default LimitedAccessCardComponent;
